const DEFAULT_RUNTIME_BASE = '/';
const KNOWN_ROUTE_PATHS = ['/welcome', '/world-intro', '/story-background', '/story-intro', '/character-creation', '/main'];

function normalizeRuntimeBase(pathname: string): string {
  if (!pathname) return DEFAULT_RUNTIME_BASE;

  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return normalizedPath.endsWith('/') ? normalizedPath : `${normalizedPath}/`;
}

function looksLikeSourceServedPath(pathname: string): boolean {
  return /\/[A-Za-z]:\//.test(pathname) || pathname.includes('/src/');
}

function resolveRuntimeBaseFromLocation(pathname: string): string | null {
  if (!pathname) return null;

  if (looksLikeSourceServedPath(pathname)) {
    return DEFAULT_RUNTIME_BASE;
  }

  if (pathname.endsWith('/index.html')) {
    return normalizeRuntimeBase(pathname.slice(0, -'/index.html'.length));
  }

  const matchedRoutePath = KNOWN_ROUTE_PATHS.find(routePath => pathname === routePath || pathname.endsWith(routePath));
  if (matchedRoutePath) {
    const basePath = pathname.slice(0, -matchedRoutePath.length) || DEFAULT_RUNTIME_BASE;
    return normalizeRuntimeBase(basePath);
  }

  if (pathname.endsWith('/')) {
    return normalizeRuntimeBase(pathname);
  }

  return null;
}

export function resolveRuntimeBase(
  moduleUrl: string,
  currentPathname: string = typeof window !== 'undefined' ? window.location.pathname : '',
): string {
  const locationBase = resolveRuntimeBaseFromLocation(currentPathname);
  if (locationBase) {
    return locationBase;
  }

  try {
    const moduleBase = new URL('./', moduleUrl).pathname;
    if (looksLikeSourceServedPath(moduleBase)) {
      return DEFAULT_RUNTIME_BASE;
    }

    return normalizeRuntimeBase(moduleBase);
  } catch {
    return DEFAULT_RUNTIME_BASE;
  }
}
